import React, { useMemo, useEffect, useState, memo } from 'react'
import { useSelector } from 'react-redux'

import styled from 'styled-components'
import { useToasts } from 'react-toast-notifications'

import axiosInstance from '../../../../../services/config/AxiosIntance'

import Table from '../../../../../components/Table'
import Loader from '../../../../../components/Loader'
import Flex from '../../../../../components/layouts/Flex'
import DashboardItemTitle from '../../components/DashboardItemTitle'
import NoData from '../../components/NoData'

import CSVDownloader from '../../../../../lib/CSVDownloader'

const RecruitmentStageBreakdown = () => {
  const { addToast } = useToasts()

  const filters = useSelector((state) => state.dashboard.filters)

  const [totalPage, setTotalPage] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [rowCount, setRowCount] = useState(0)

  const [loading, setLoading] = useState(false)
  const [tableData, setTableData] = useState([])

  useEffect(() => {
    fetchData()
  }, [filters])

  const fetchData = async () => {
    try {
      setLoading(true)

      const queryParams = new URLSearchParams(filters).toString()
      const fetchedPageUrl = `/jobs/recruitment-type-breakdown/fetchPage?${queryParams}&pageNumber=${currentPage}&pageSize=${pageSize}`

      const result = await axiosInstance.get(fetchedPageUrl)

      setTableData(result?.data?.data)

      setTotalPage(result?.data?.pagination?.pageCount)
      setRowCount(result?.data?.pagination?.rowCount)
      setCurrentPage(result?.data?.pagination?.page)
      setPageSize(result?.data?.pagination?.pageSize)
    } catch (error) {
      addToast('Something went wrong', {
        appearance: 'error',
        autoDismiss: true,
      })
    } finally {
      setLoading(false)
    }
  }

  const handleExport = async () => {
    try {
      const queryFilter = {
        dates: filters?.dates?.toString(),
      }
      const queryParams = new URLSearchParams(queryFilter).toString()
      const url = `/jobs/recruitment-type-breakdown/fetchAll?${queryParams}&pageNumber=${currentPage}&pageSize=${pageSize}`
      const result = await axiosInstance.get(url)
      const response = result?.data?.data.map((e) => ({
        Client: e.client,
        'Recruitment Type': e.recruitment_stage,
        Total: e.total,
      }))
      CSVDownloader.downloadUnparsedCSV(
        response,
        'Recruitment_Type_Breakdown.csv'
      )
    } catch (error) {
      addToast('Something went wrong', {
        appearance: 'error',
        autoDismiss: true,
      })
    }
  }

  const tableColumns = useMemo(
    () => [
      {
        Header: 'Client',
        accessor: 'client',
      },
      {
        Header: 'Recruitment Type',
        accessor: 'recruitment_stage',
      },
      {
        Header: 'Total',
        accessor: 'total',
      },
    ],
    []
  )

  return (
    <StyledRecruitmentTypeBreakdown>
      <Flex justify="space-between">
        <DashboardItemTitle title="Recruitment Type Breakdown List" />
        <Flex gap="0.5rem">
          <ExportButton onClick={handleExport}>Export</ExportButton>
        </Flex>
      </Flex>

      {loading && <Loader />}

      {tableData?.length > 0 ? (
        <Table
          height="100%"
          totalPage={totalPage}
          currentPage={currentPage}
          pageSize={pageSize}
          rowCount={rowCount}
          data={tableData}
          columns={tableColumns}
          setNewPageSize={setPageSize}
          setCurrentPage={setCurrentPage}
          fetchData={fetchData}
          onClick={() => null}
        ></Table>
      ) : (
        <NoData />
      )}
    </StyledRecruitmentTypeBreakdown>
  )
}

export default memo(RecruitmentStageBreakdown)

const StyledRecruitmentTypeBreakdown = styled.div`
  width: 100%;
  height: 100%;
`
const ExportButton = styled.button`
  padding: 0.35rem 0.65rem;
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: uppercase;
  text-overflow: ellipsis;
  overflow: hidden;
  background-color: black;
  color: white;
  border-radius: 100px;
  word-spacing: 3px;
`